import {
    BACKSPACE,
    DASH,
    DELETE,
    LEFT_ARROW,
    NUMPAD_MINUS,
    PERIOD,
    RIGHT_ARROW,
    SPACE,
    TAB,
} from '@angular/cdk/keycodes';

export function validateOnlyNumberKeyboardEvent(
    $event: KeyboardEvent,
    isDecimalAllowed?: boolean,
    isNegativeNumbersAllowed?: boolean,
): boolean {
    const allowExtraKeyCodes: number[] = [BACKSPACE, DELETE, LEFT_ARROW, RIGHT_ARROW, TAB];

    if (isDecimalAllowed) allowExtraKeyCodes.push(PERIOD);

    if (isNegativeNumbersAllowed) {
        allowExtraKeyCodes.push(NUMPAD_MINUS);
        allowExtraKeyCodes.push(DASH);
    }

    return allowExtraKeyCodes.includes($event.keyCode) || (!isNaN(Number($event.key)) && $event.keyCode !== SPACE);
}
